export const getDataAttributes = (props) => {
  return Object.keys(props)
    .filter(key => (key.indexOf('data') === 0))
    .reduce((memo, key) => {
      memo[key] = props[key]
      return memo
    }, {})
}
